import { DocumentNode, gql } from '@apollo/client';
import { HStack, Text } from '@chakra-ui/react';

import { RsvpIcon } from '@/components/EventStuff/components/RsvpMenu/components/RsvpSelect/RsvpSelect';
import { ERsvpResponse } from '@/graphql-types/globalTypes';
import { shouldUseMemberLearningRegistrationCopy } from '@/utilities/memberLearningRegistrationCopy';

import { ReadOnlyRsvpButton_EventFragment } from './graphql-types/ReadOnlyRsvpButton_EventFragment';

export const ReadOnlyRsvpButton: React.FC<{
  event: ReadOnlyRsvpButton_EventFragment;
}> & { eventFragment: DocumentNode } = ({ event }) => {
  const useLearningRegistrationCopy =
    shouldUseMemberLearningRegistrationCopy(event);
  const currentUserRsvp =
    event.__typename === 'SimpleEventV2' && event.currentUserRsvp
      ? event.currentUserRsvp
      : undefined;

  return (
    <HStack
      spacing="2"
      py="2"
      px="4"
      bg="gray.100"
      borderRadius="lg"
      justifyContent="center"
    >
      {currentUserRsvp && <RsvpIcon response={currentUserRsvp.response} />}
      {currentUserRsvp ? (
        <Text>{`RSVP'd ${
          {
            [ERsvpResponse.GOING]: 'Going',
            [ERsvpResponse.MAYBE]: 'Maybe',
            [ERsvpResponse.NOT_GOING]: 'Not Going',
          }[currentUserRsvp.response]
        }`}</Text>
      ) : (
        <Text>
          {useLearningRegistrationCopy
            ? 'You did not Enroll'
            : 'You did not RSVP'}
        </Text>
      )}
    </HStack>
  );
};

ReadOnlyRsvpButton.eventFragment = gql`
  fragment ReadOnlyRsvpButton_EventFragment on EventV2 {
    _id
    isCourseWorkshop
    ... on SimpleEventV2 {
      currentUserRsvp {
        _id
        response
      }
      intutoCourseCollection {
        collectionId
      }
    }
    ... on ConferenceEventV2 {
      intutoCourseCollection {
        collectionId
      }
    }
  }
`;
